import { useEffect, useState } from 'react'
import { Avatar, Button, Col, Form, Input, Row, Typography, Grid } from 'antd'
import { useStoreActions } from 'easy-peasy'
import { useTranslate } from 'hooks/translate'
import axios from 'axios'
import Logo from './image/Pruksa Logo A.png'
import RiskLogo from './image/risk-logo.png'

const { useBreakpoint } = Grid
export default function Login () {
  const screens = useBreakpoint()
  const { t } = useTranslate()
  const [formControls, setFormControls] = useState({
    username: '',
    password: '',
  })
  const [config, setConfig] = useState(null)
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_CONFIG}`)
      .then((response) => {
        setConfig(response.data)
      })
      .catch((error) => {
        console.error('Error loading config.json:', error)
      })
  }, [])

  const loginAction = useStoreActions((action) => action.auth.login)

  const handleLogin = () => {
    loginAction(formControls)
  }

  return (
    <Row
      justify='space-between'
      // align='middle'
      style={{ height: '100vh' }}
    >
      {Object.entries(screens)
        .filter((screen) => !!screen[1])
        .find((screen) => screen[0] === 'lg') ? (
        <Col
          lg={8}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            // minHeight: '100vh',
            backgroundColor: '#ADAEBA',
            // height: '100vh',
          }}
        >
          <img
            src={Logo}
            alt='Logo'
            // width='150' height='150'
          />
        </Col>
      ) : null}

      <Col xs={24} lg={16} style={{ width: '100%', paddingTop: '10%' }}>
        {/* <Row justify='space-around' align='middle' gutter={[0, 0]} style={{ height: '100%' }}> */}
        {/* <Col xs={24}> */}
        <Row justify='center' align='middle'>
          <Col span={3} style={{ textAlign: 'center' }}>
            <Avatar src={RiskLogo} size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }} />
          </Col>
          <Col span={17}>
            <Typography.Title
              level={3}
              style={{ marginBottom: 0, fontFamily: 'monospace', wordBreak: 'break-word' }}
            >
              WELCOME TO INCIDENT & RISK MANAGEMENT SYSTEM
            </Typography.Title>
          </Col>
        </Row>
        {/* </Col> */}
        {/* <Col xs={24}> */}
        <Row
          justify='center'
          align='middle'
          style={{
            fontStyle: 'italic',
            fontFamily: 'monospace',
            fontSize: '16px',
          }}
        >
          <Col style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>Please contact Risk Management Team</Typography.Text>
            <Typography.Text>for system access authorization</Typography.Text>
            <Typography.Text strong>
              Tel: {config?.tel1 || ''}, {config?.tel2 || ''}
            </Typography.Text>
            <Typography.Text strong>Email: {config?.email || ''}</Typography.Text>
          </Col>
        </Row>
        {/* </Col> */}
        {/* <Col xs={24}> */}
        {/* <div style={{ display: 'flex', justifyContent: 'center' }}> */}
        <Row>
          <Col
            span={12}
            offset={6}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Form
              name='basic'
              style={{ margin: 8, width: '100%' }}
              wrapperCol={{ span: 12 }}
              onFinish={handleLogin}
              autoComplete='off'
            >
              <Form.Item
                labelCol={{
                  span: 12,
                }}
                wrapperCol={{
                  span: 18,
                }}
                name='username'
                rules={[
                  { required: true, message: t('Please input your username!') },
                  {
                    validator: async (rule, value) => {
                      const validThai = value.match`[^\u0000-\u007F]+`

                      if (validThai) {
                        return Promise.reject(
                          new Error(
                            validThai[0]
                              ? `" ${validThai[0]} " is not allowed`
                              : 'Please enter only A-Z,a-Z,0-9'
                          )
                        )
                      }

                      return Promise.resolve()
                    },
                  },
                ]}
                style={{ justifyContent: 'center' }}
              >
                <Input
                  placeholder='Username'
                  onChange={(e) =>
                    setFormControls((prev) => {
                      return { ...prev, username: e.target.value }
                    })
                  }
                  value={formControls}
                  autoComplete='off'
                  style={{ justifyContent: 'center' }}
                />
              </Form.Item>

              <Form.Item
                labelCol={{
                  span: 12,
                }}
                wrapperCol={{
                  span: 18,
                }}
                name='password'
                rules={[{ required: true, message: t('Please input your password!') }]}
                style={{ justifyContent: 'center' }}
              >
                <Input.Password
                  placeholder='Password'
                  onChange={(e) =>
                    setFormControls((prev) => {
                      return { ...prev, password: e.target.value }
                    })
                  }
                  value={formControls}
                  autoComplete='off'
                />
              </Form.Item>

              <Form.Item
                labelCol={{
                  span: 12,
                }}
                wrapperCol={{
                  span: 18,
                }}
                style={{ justifyContent: 'center', textAlign: 'center' }}
              >
                <Button type='primary' htmlType='submit'>
                  {t('Submit')}
                </Button>
                <Row justify='center' style={{ marginTop: 8 }}>
                  <Typography.Text style={{ color: '#ADAEBA' }}>
                    โปรดระบุ Username และ Password เข้าเครื่องคอมพิวเตอร์ของท่าน
                  </Typography.Text>
                </Row>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        {/* </div> */}
        {/* </Col> */}
        {/* </Row> */}
      </Col>
    </Row>
  )
}
